/* Bouton « ← Image » de la fiche produit (chantier 70, 21/10/2026).

   La fiche s'ouvre sur la vignette, l'œuvre entière. Une pastille de format fait défiler la
   galerie jusqu'au mockup de ce format (product-info.js), et sur téléphone on glisse d'image
   en image. Le bouton, à côté du libellé « Format » (product-variant-picker.liquid), ramène la
   galerie sur la vignette. Il ne se montre que quand une autre image est affichée ; caché, il
   garde sa place (data-visible, voir sp-finition.css).

   Dawn remplace le sélecteur de variantes à chaque changement : le bouton est donc retrouvé à
   chaque fois (clic délégué au document, état recalculé quand la fiche change). L'image affichée
   se lit à deux signaux : `slideChanged`, émis par le slider de Dawn à chaque défilement
   (glissement, vignettes), et la classe `is-active` que pose setActiveMedia (pastille).
   Un clic sur la pastille déjà cochée montre aussi l'image de son format (voir plus bas). */
(() => {
  if (window.spRetourImage) return;
  window.spRetourImage = true;

  const galerie = (section) => document.getElementById(`MediaGallery-${section}`);
  const affichee = {};      // section → identifiant du média affiché

  const sync = (section) => {
    const id = affichee[section];
    if (!id) return;
    document.querySelectorAll(`[data-sp-oeuvre][data-section="${section}"]`).forEach((b) => {
      b.dataset.visible = String(id !== b.dataset.spOeuvre);
    });
  };

  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-sp-oeuvre]');
    if (!b) return;
    galerie(b.dataset.section)?.setActiveMedia?.(b.dataset.spOeuvre, false);
  });

  // Pastille déjà cochée (22/10) : Dawn ne voit aucun changement de variante, donc rien ne bouge.
  // Comme la fiche s'ouvre sur l'œuvre entière, la pastille cochée au chargement (A4, 30×30) ne
  // montrait jamais son mockup. On note si la pastille l'était déjà quand on appuie dessus, et
  // le clic affiche alors l'image de la variante sélectionnée.
  const pastille = (t) => {
    const label = t.closest && t.closest('variant-selects label');
    return label?.control || (t.closest && t.closest('variant-selects input[type="radio"]'));
  };
  let dejaCochee = null;
  document.addEventListener('pointerdown', (e) => {
    const input = pastille(e.target);
    dejaCochee = input && input.checked ? input : null;
  }, true);
  document.addEventListener('click', (e) => {
    const input = pastille(e.target);
    if (!input || input !== dejaCochee) return;
    dejaCochee = null;      // le clic du libellé est suivi d'un clic sur le bouton radio
    const selects = input.closest('variant-selects');
    const section = selects?.dataset.section;
    let variante = null;
    try {
      variante = JSON.parse(selects?.querySelector('[data-selected-variant]')?.textContent || 'null');
    } catch (_) {
      return;
    }
    const media = variante?.featured_media?.id;
    if (section && media) galerie(section)?.setActiveMedia?.(`${section}-${media}`, false);
  });

  const suivre = (g) => {
    const section = g.id.replace('MediaGallery-', '');
    const list = g.querySelector('.product__media-list');
    const lire = () => {
      affichee[section] = list?.querySelector(':scope > li.is-active')?.dataset.mediaId || affichee[section];
      sync(section);
    };
    g.querySelector('[id^="GalleryViewer"]')?.addEventListener('slideChanged', (e) => {
      affichee[section] = e.detail?.currentElement?.dataset.mediaId || affichee[section];
      sync(section);
    });
    if (list) {
      new MutationObserver(lire).observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    // Un nouveau sélecteur arrive avec un bouton caché : on lui redonne l'état de la galerie.
    const info = document.getElementById(`ProductInfo-${section}`);
    if (info) new MutationObserver(() => sync(section)).observe(info, { childList: true, subtree: true });
    lire();
  };

  const start = () => document.querySelectorAll('media-gallery[id^="MediaGallery-"]').forEach(suivre);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
